"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesTriggerParams = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const TriggersApi_1 = require("../../../apis/TriggersApi");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const errors_1 = require("../../../interface/errors");
const FutureTradeProcessor_1 = require("./FutureTradeProcessor");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const TradeValidate_1 = require("./TradeValidate");
const useFuturesTriggerParams = (props) => {
    const { triggerPrice, triggerPriceType, curPrice, symbolInfo, isFocused, orderSide, price } = props;
    const indexPrice = (0, trade_quotation_lib_1.useFuturesIndex)({ base: symbolInfo.base, quote: symbolInfo.quote, isActive: isFocused });
    // 触发价所依赖的当前价格
    const depCurPrice = triggerPriceType === interface_1.TriggerPriceType.LAST_PRICE ? curPrice : indexPrice === null || indexPrice === void 0 ? void 0 : indexPrice.mark_price;
    // 手动单把触发价当做当前价
    const customParams = (0, FutureTradeProcessor_1.useFutureTradeParams)(Object.assign(Object.assign({}, props), { triggerPrice: triggerPrice }));
    const { verifyCanTrade: verifyCustomOrderCanTrade, tradeConformParams: _tradeConformParams } = customParams;
    const isLimit = props.orderTypeUI === interface_1.FuturesOrderTypeUI.limit;
    /**新增额外的参数用于二次弹窗 */
    const tradeConformParams = (0, react_1.useMemo)(() => Object.assign(_tradeConformParams, { triggerPrice, triggerPriceType }), [_tradeConformParams, triggerPrice, triggerPriceType]);
    const triggerType = new trade_utils_lib_1.SafeDecimal(triggerPrice).greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(depCurPrice))
        ? interface_1.TriggerType.GREATER_EQUAL
        : interface_1.TriggerType.LESS_EQUAL;
    const verifyCanTrade = (0, react_1.useCallback)(() => {
        return (() => {
            if (!curPrice || !Number(curPrice)) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_NO_CURRENT_PRICE);
            }
            if (!triggerPrice || !Number(triggerPrice)) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_TRIGGER_PRICE_NONE);
            }
            if (isLimit) {
                const triggerPriceD = new trade_utils_lib_1.SafeDecimal(triggerPrice);
                if (!(!price || !Number(price))) {
                    const priceD = new trade_utils_lib_1.SafeDecimal(price);
                    if (orderSide === interface_1.CustomOrderSide.BUY) {
                        // 多头，限价大于触发价时报错，需小于等于触发价
                        if (priceD.gt(triggerPriceD)) {
                            return (0, rxjs_1.throwError)((0, errors_1.cloneError)(errors_1.TRADE_LIMIT_GT_TRIGGER, {
                                price: TradeValidate_1.TradeValidator.formatValue(triggerPriceD, symbolInfo, interface_1.InvestSymbolSide.quote, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR),
                            }));
                        }
                    }
                    else {
                        // 空头，限价小于等于触发价时报错，需大于等于触发价
                        if (priceD.lt(triggerPriceD)) {
                            return (0, rxjs_1.throwError)((0, errors_1.cloneError)(errors_1.TRADE_LIMIT_LT_TRIGGER, {
                                price: TradeValidate_1.TradeValidator.formatValue(triggerPriceD, symbolInfo, interface_1.InvestSymbolSide.quote, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                            }));
                        }
                    }
                }
            }
            return verifyCustomOrderCanTrade().pipe((0, operators_1.map)((req) => {
                const request = Object.assign(Object.assign({}, req.request), { trigger_price: triggerPrice, trigger_price_type: triggerPriceType, trigger_type: triggerType });
                return {
                    request,
                    status: req.status,
                };
            }));
        })().pipe((0, operators_1.catchError)((error) => {
            return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
        }));
    }, [curPrice, isLimit, orderSide, price, symbolInfo, triggerPrice, triggerPriceType, triggerType, verifyCustomOrderCanTrade]);
    const createOrder = (0, react_1.useCallback)(() => {
        return verifyCanTrade().pipe((0, operators_1.mergeMap)((req) => {
            return (0, TriggersApi_1.createTriggerOrder)(req.request);
        }));
    }, [verifyCanTrade]);
    return Object.assign(Object.assign({}, customParams), { triggerType, verifyCanTrade, createOrder, tradeConformParams });
};
exports.useFuturesTriggerParams = useFuturesTriggerParams;
